import React, { useEffect } from 'react';

const BusinessHoursTemplateWidget = ({ selectedLayout, isTemplateId, widgetId, businessHoursTabData }) => {
    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/business-hours/temp-css/BusinessHoursWidget.css`;
        if (widgetId) {
            link.setAttribute("business-hours-data-dynamic-css", "business-hours");
        } else {
            link.setAttribute("data-dynamic-css", "business-hours");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="business-hours"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    const {
        is_website_frontend,
        is_sunday_on,
        sunday_start_time,
        sunday_end_time,
        is_monday_on,
        monday_start_time,
        monday_end_time,
        is_tuesday_on,
        tuesday_start_time,
        tuesday_end_time,
        is_wednesday_on,
        wednesday_start_time,
        wednesday_end_time,
        is_thursday_on,
        thursday_start_time,
        thursday_end_time,
        is_friday_on,
        friday_start_time,
        friday_end_time,
        is_saturday_on,
        saturday_start_time,
        saturday_end_time,
        business_name,
        about_company,
        is_show_labels_on,
        is_show_icons_on,
        background_color,
        text_color,
        icons_color,
        open_status_color,
        closed_status_color,
        closed_soon_status_color,
        text_size,
        position_alignment,
        layout_custom_width,
    } = businessHoursTabData || {};

    const days = [
        { name: "Sunday", isOpen: Number(is_sunday_on), start: sunday_start_time, end: sunday_end_time },
        { name: "Monday", isOpen: Number(is_monday_on), start: monday_start_time, end: monday_end_time },
        { name: "Tuesday", isOpen: Number(is_tuesday_on), start: tuesday_start_time, end: tuesday_end_time },
        { name: "Wednesday", isOpen: Number(is_wednesday_on), start: wednesday_start_time, end: wednesday_end_time },
        { name: "Thursday", isOpen: Number(is_thursday_on), start: thursday_start_time, end: thursday_end_time },
        { name: "Friday", isOpen: Number(is_friday_on), start: friday_start_time, end: friday_end_time },
        { name: "Saturday", isOpen: Number(is_saturday_on), start: saturday_start_time, end: saturday_end_time },
    ];

    const parse12HourTime = (timeStr) => {
        const date = new Date();
        const [time, modifier] = timeStr.split(" ");
        let [hours, minutes] = time.split(":").map(Number);

        if (modifier === "PM" && hours < 12) hours += 12;
        if (modifier === "AM" && hours === 12) hours = 0;

        date.setHours(hours, minutes, 0, 0);
        return date;
    };

    const currentDay = new Date().getDay();
    const now = new Date();
    const today = days[currentDay];

    let businessStatus = "closed";
    let h4Content = "";

    if (today.isOpen && today.start && today.end) {
        const startTime = parse12HourTime(today.start);
        const endTime = parse12HourTime(today.end);

        if (now < startTime) {
            businessStatus = "closed";
            h4Content = `Opens today at ${today.start}`;
        } else if (now >= endTime) {
            businessStatus = "closed";
            // Find next open day
            let nextOpen = null;
            for (let i = 1; i <= 7; i++) {
                const nextIndex = (currentDay + i) % 7;
                if (days[nextIndex].isOpen) {
                    nextOpen = days[nextIndex];
                    break;
                }
            }
            h4Content = nextOpen ? `Opens ${nextOpen.name} at ${nextOpen.start}` : "Closed";
        } else {
            const minutesLeft = Math.floor((endTime - now) / 60000);
            if (minutesLeft <= 60) {
                businessStatus = "closingSoon";
                h4Content = `Closing soon in ${minutesLeft} min${minutesLeft > 1 ? "s" : ""}`;
            } else {
                businessStatus = "open";
                h4Content = `Open until ${today.end}`;
            }
        }
    } else {
        // Today is closed, find next open day
        let nextOpen = null;
        for (let i = 1; i <= 7; i++) {
            const nextIndex = (currentDay + i) % 7;
            if (days[nextIndex].isOpen) {
                nextOpen = days[nextIndex];
                break;
            }
        }
        h4Content = nextOpen ? `Opens ${nextOpen.name} at ${nextOpen.start}` : "Closed";
    }

    const statusColors = {
        open: open_status_color,
        closingSoon: closed_soon_status_color,
        closed: closed_status_color,
    };

    const statusColor = statusColors[businessStatus];

    return (
        <div className={`business_main upgadeify business-hours-business-hours-temp ${is_website_frontend}`}>
            <div className='businesshours_box' style={{ backgroundColor: background_color, borderRadius: "12px", padding: "30px", width: layout_custom_width }}>
                <h2 className='business_name' style={{ color: text_color, textAlign: position_alignment }}>{business_name}</h2>
                <h3 className='abount_company' style={{ color: text_color, textAlign: position_alignment }}>{about_company}</h3>
                <h4 className='title_business' style={{ color: statusColor, fontSize: text_size, textAlign: position_alignment }}>
                    {Number(is_show_icons_on) === 1 && (
                        <svg style={{ marginRight: '5px' }} width={text_size} height={text_size} viewBox="0 0 24 24" fill="none" stroke={icons_color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                    )}
                    {Number(is_show_labels_on) === 1 && (
                        <label style={{ fontWeight: 'bold' }}>
                            Hours:
                        </label>
                    )}
                    &nbsp;{h4Content}
                </h4>
                <table>
                    {days.map((day, index) => {
                        const isToday = index === currentDay;
                        const isClosedBySetting = !day.isOpen;
                        const isBold = isToday ? "bold" : "normal";
                        const dayLabel = isToday ? "Today" : day.name;
                        const timeText = isClosedBySetting ? "Closed" : `${day.start} - ${day.end}`;

                        let rowColor = text_color;

                        if (isClosedBySetting) {
                            rowColor = closed_status_color;
                        } else if (isToday) {
                            const startTime = parse12HourTime(day.start);
                            const endTime = parse12HourTime(day.end);
                            const isOpenNow = now >= startTime && now < endTime;
                            if (!isOpenNow) {
                                rowColor = closed_status_color;
                            }
                        }

                        return (
                            <tr key={index}>
                                <td style={{ color: rowColor, fontSize: text_size, fontWeight: isBold, textAlign: position_alignment }}>
                                    {dayLabel}
                                </td>
                                <td style={{ color: rowColor, fontSize: text_size, fontWeight: isBold, textAlign: position_alignment }}>
                                    {timeText}
                                </td>
                            </tr>
                        );
                    })}
                </table>
            </div>
        </div>
    );
};

export default BusinessHoursTemplateWidget;
